import http from "./client";
import { IPaginator } from "./types";

export type TTranscriptionStatus = 'processing' | 'inqueue' | 'error' | 'done' | 'published'

export interface ITranscriptionFile {
    id: number,
    preview: string,
    link: string,
    name: string,
}

export interface ITranscriptionPrice {
    model: string,
    name: string,
    price: number
}

export interface ITranscriptionPrices {
    languages: {language: string, name: string}[],
    prices: ITranscriptionPrice[],
    duration: number,
    file: ITranscriptionFile,
}

export interface IParagraph {
    start: number,
    end: number,
    num_words: number,
    text: string,
}

export interface ITranscription {
    id: number,
    model: string,
    status: TTranscriptionStatus,
    title: string,
    file: ITranscriptionFile,
    paragraphs: IParagraph[],
    prices: ITranscriptionPrice[]
}

export interface ITranscriptionList {
    data: ITranscription[],
    paginator: IPaginator,
}

export interface IBalance {
    ai: number,
    author_id: number,
    balance: number,
    proctoring: number,
}

async function getPrices(courseId: string, fileId: string): Promise<ITranscriptionPrices> {
    const response = await http.post<{data: ITranscriptionPrices}>(`/api/v2/course/${courseId}/file/${fileId}/transcript/cost`);
    return response.data.data;
}

async function getBalance(courseId: string): Promise<IBalance> {
    const response = await http.get<{data: IBalance}>(`/api/v2/user/balance?course_id=${courseId}`);
    return response.data.data;
}

async function getTranscriptions(courseId: string, page: number, limit: number): Promise<ITranscriptionList> {
    const response = await http.get<ITranscriptionList>(`/api/v2/course/${courseId}/transcripts`, {
        params: {page, limit}
      });
    return response.data;
}

async function getTranscription(courseId: string, transcriptionId: number): Promise<ITranscription> {
    const response = await http.get<{data: ITranscription}>(`/api/v2/course/${courseId}/transcripts/${transcriptionId}`);
    return response.data.data;
}

async function createTranscription(courseId: string, data: any): Promise<ITranscription> {
    const response = await http.post<ITranscription>(`/api/v2/course/${courseId}/transcribe`, data);
    return response.data;
}

async function deleteTranscription(courseId: string, transcriptionId: number): Promise<ITranscription> {
    const response = await http.delete<{data: ITranscription}>(`/api/v2/course/${courseId}/transcripts/${transcriptionId}`);
    return response.data.data;
}

async function publishTranscription(courseId: string, transcriptionId: number): Promise<{result: string}> {
    const response = await http.put<{result: string}>(`/api/v2/course/${courseId}/transcripts/${transcriptionId}`,{
        status: 'published'
    });
    return response.data;
}

async function unpublishTranscription(courseId: string, transcriptionId: number): Promise<{result: string}> {
    const response = await http.put<{result: string}>(`/api/v2/course/${courseId}/transcripts/${transcriptionId}`, {
        status: 'draft'
    });
    return response.data;
}

async function getTranscriptionByFile(courseId: string, fileId: number): Promise<ITranscription> {
    const response = await http.get<{data: ITranscription}>(`/api/v2/course/${courseId}/file/${fileId}/transcript`);
    return response.data.data;
}

export const transcriptions = {
    getPrices,
    getBalance,
    getTranscriptions,
    getTranscription,
    createTranscription,
    deleteTranscription,
    publishTranscription,
    unpublishTranscription,
    getTranscriptionByFile,
}
